/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierCrmStage } from "./CarrierCrmStage";
import {
  CarrierCrmStageFromJSON,
  CarrierCrmStageFromJSONTyped,
  CarrierCrmStageToJSON,
  CarrierCrmStageToJSONTyped,
} from "./CarrierCrmStage";

/**
 * A carrier someone has just met, registered so the relationship can be tracked from day one. The identifier is permanent: if the carrier is integrated later, the Kotlin integration must reuse it or the CRM history detaches from the integration.
 * @export
 * @interface AddCarrierRequest
 */
export interface AddCarrierRequest {
  /**
   * Normalised on arrival to the shape every integration identifier and registry row has: lowercase letters and digits run together. "Day \& Ross" becomes "dayross".
   * @type {string}
   * @memberof AddCarrierRequest
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof AddCarrierRequest
   */
  name: string;
  /**
   *
   * @type {CarrierCrmStage}
   * @memberof AddCarrierRequest
   */
  crmStage: CarrierCrmStage;
}

/**
 * Check if a given object implements the AddCarrierRequest interface.
 */
export function instanceOfAddCarrierRequest(
  value: object,
): value is AddCarrierRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("crmStage" in value) || value["crmStage"] === undefined) return false;
  return true;
}

export function AddCarrierRequestFromJSON(json: any): AddCarrierRequest {
  return AddCarrierRequestFromJSONTyped(json, false);
}

export function AddCarrierRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddCarrierRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    name: json["name"],
    crmStage: CarrierCrmStageFromJSON(json["crmStage"]),
  };
}

export function AddCarrierRequestToJSON(json: any): AddCarrierRequest {
  return AddCarrierRequestToJSONTyped(json, false);
}

export function AddCarrierRequestToJSONTyped(
  value?: AddCarrierRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    name: value["name"],
    crmStage: CarrierCrmStageToJSON(value["crmStage"]),
  };
}
